export const getApplicantAttributes = `
    query getApplicantAttributes {
        getApplicantAttributes {
            attributes {
                key
                label
                type
            }
        }
    }
`